/**
 * Formátovací helpery fáze 4 (přidělení jednotek). Peněžní a časové helpery
 * přebírá z fronty plateb — nezdvojujeme je (jeden zdroj pravdy pro CZK/čas).
 */

import { formatCzk, formatDateTime } from '../platby/format'

// Jednotky se drží na 8 des. místech (kontrakt numeric(28,8)); nadbytečné nuly netiskneme.
const unitsNumber = new Intl.NumberFormat('cs-CZ', { maximumFractionDigits: 8 })

/** Počet/cena jednotek — např. „1,10607527" nebo „186 000 000". */
export function formatUnits(units: number): string {
  return unitsNumber.format(units)
}

// Vždy jedno desetinné místo, ať odchylka „skáče" konzistentně (0,1234 → „12,3 %").
const percentNumber = new Intl.NumberFormat('cs-CZ', {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
})

/** Poměr → procenta, např. 0,1234 → „12,3 %". */
export function formatPercent(ratio: number): string {
  return `${percentNumber.format(ratio * 100)} %`
}

/**
 * Datum bez času z ISO „yyyy-MM-dd" → „dd.MM.yyyy". Rozdělením stringu (ne přes
 * Date) se vyhneme posunu časové zóny u půlnočních UTC datumů.
 */
export function formatDate(iso: string): string {
  const [year, month, day] = iso.slice(0, 10).split('-')
  return day && month && year ? `${day}.${month}.${year}` : iso
}

/**
 * Dnešek jako „yyyy-MM-dd" v MÍSTNÍM čase. `toISOString()` vrací UTC — mezi
 * půlnocí a 2:00 SELČ by předvyplnil včerejší datum.
 */
export function todayIso(): string {
  const now = new Date()
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`
}

/** Aktuální měsíc „yyyy-MM" v místním čase (stejný důvod jako u todayIso). */
export function currentMonthIso(): string {
  return todayIso().slice(0, 7)
}

export { formatCzk, formatDateTime }
